// ALTIVEST Shopify: torba na natywnym koszyku (/cart.js), port cart.js z wersji żywej (ten sam markup i teksty).
(function () {
  'use strict';
  var root = document.querySelector('[data-cart-page]');
  if (!root) return;
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var DATA = window.ALTIVEST_PRODUCT_DATA || { products: [] };
  var CP = (window.ALTIVEST_COLOR_PHOTOS || {}).products || {};
  var M = window.AltivestCartModel;
  var $ = function (s) { return root.querySelector(s); };
  var rows = $('[data-lc-rows]'), status = $('[data-lc-status]');
  var DOP = 'altivest-doplata-tekst';
  var cart = { items: [], total_price: 0 };
  var el = function (tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text !== undefined) e.textContent = text; return e; };
  var byModel = function (m) { return DATA.products.find(function (p) { return p.model === m; }); };
  var fmt = function (minor) { return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' }).format(minor / 100); };
  var labels = { 'Tekst': 'Tekst haftu', 'Font': 'Krój pisma', 'Nić': 'Kolor nici', 'Pozycja': 'Miejsce' };
  var order = ['Personalizacja', 'Wzór', 'Pozycja', 'Tekst', 'Font', 'Nić', 'Motyw'];

  function api(path, body) {
    return fetch(R + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Błąd koszyka.'); return d; }); });
  }
  function load() { return api('cart.js').then(function (c) { cart = c; render(); }); }
  function mains() { return cart.items.filter(function (i) { return i.handle !== DOP; }); }
  function extrasFor(item) { var k = (item.properties || {})._av_key; return k ? cart.items.filter(function (i) { return i.handle === DOP && (i.properties || {})._av_for === k; }) : []; }
  function photoFor(item) {
    // zdjęcie wariantu Shopify (kolor); bez zdjęcia wariantu: zdjęcie produktu z koszyka
    if (item.featured_image && item.featured_image.url) return item.featured_image.url;
    if (item.image) return item.image;
    var p = byModel((item.properties || {})._av_model);
    return (p && (p.cartImage || p.image)) || '';
  }
  function render() {
    rows.replaceChildren();
    var list = mains(); var n = list.length;
    $('[data-lc-empty]').hidden = n > 0;
    $('[data-lc-full]').hidden = n === 0;
    var pcs = list.reduce(function (a, i) { return a + i.quantity; }, 0);
    $('[data-lc-count]').textContent = pcs ? pcs + ' szt.' : '';
    $('[data-lc-pos]').textContent = String(n);
    $('[data-lc-pcs]').textContent = String(pcs);
    var totalEl = $('[data-lc-total]');
    if (totalEl) totalEl.textContent = n ? fmt(cart.total_price) : 'Cena wkrótce';
    list.forEach(function (item) {
      var name = item.product_title || item.title;
      var href = item.url || '#';
      var row = el('article', 'lc-row'); row.dataset.key = item.key;
      var ph = el('a', 'lc-ph'); ph.href = href;
      var src = photoFor(item);
      if (src) { var img = el('img'); img.src = src; img.alt = name; img.width = 240; img.height = 300; img.loading = 'lazy'; ph.append(img); }
      row.append(ph);
      var info = el('div', 'lc-info');
      var h = el('h3'); var a = el('a', null, name); a.href = href; h.append(a); info.append(h);
      var dl = el('dl'); var props = item.properties || {};
      (item.options_with_product || []).forEach(function (o) { if (!o || !o.value || o.name === 'Title' || o.value === 'Default Title') return; var d0 = el('div'); d0.append(el('dt', null, o.name), el('dd', null, o.value)); dl.append(d0); });
      order.forEach(function (k) { var v = props[k]; if (!v) return; var d = el('div'); d.append(el('dt', null, labels[k] || k), el('dd', null, v)); dl.append(d); });
      info.append(dl);
      var ctr = el('div', 'lc-ctr');
      var qty = el('div', 'qty');
      var minus = el('button', null, '\u2212'); minus.type = 'button'; minus.setAttribute('aria-label', 'Mniej: ' + name); minus.disabled = item.quantity <= 1;
      var out = el('output', null, String(item.quantity)); out.setAttribute('aria-live', 'polite');
      var plus = el('button', null, '+'); plus.type = 'button'; plus.setAttribute('aria-label', 'Więcej: ' + name);
      minus.addEventListener('click', function () { change(item, item.quantity - 1); });
      plus.addEventListener('click', function () { change(item, item.quantity + 1); });
      qty.append(minus, out, plus);
      var rm = el('button', 'link-u lc-rm', 'Usuń'); rm.type = 'button'; rm.addEventListener('click', function () { change(item, 0); });
      ctr.append(qty, rm); info.append(ctr);
      row.append(info);
      var line = item.final_line_price + extrasFor(item).reduce(function (s, e) { return s + e.final_line_price; }, 0);
      row.append(el('div', 'lc-price', line > 0 ? fmt(line) : 'Cena wkrótce'));
      rows.append(row);
    });
    var cnt = mains().reduce(function (a, i) { return a + i.quantity; }, 0);
    window.dispatchEvent(new CustomEvent('altivest:cart-change', { detail: { count: cnt } }));
  }
  function change(item, q) {
    var updates = {}; updates[item.key] = q;
    extrasFor(item).forEach(function (e) { updates[e.key] = q; });
    api('cart/update.js', { updates: updates }).then(function (c) { cart = c; render(); status.textContent = q === 0 ? 'Usunięto z torby.' : 'Zmieniono liczbę sztuk.'; })
      .catch(function (e) { status.textContent = e.message; });
  }
  $('[data-lc-pay]').addEventListener('click', function (e) { if (e.defaultPrevented || e.__inpostPickupCheckoutBypass) return; location.assign(R + 'checkout'); });
  load().catch(function () { render(); });
  void M;
})();
